import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import Lottie from "lottie-react";
import PropTypes from "prop-types";
import React from "react";
import { Modal } from "react-bootstrap";
import animationData from "../../../components/wizard/lottie/warning-light.json";

const ErrorDisplayModal = ({ modal, setModal, title, description }) => {
  const renderDescription = () => {
    if (Array.isArray(description)) {
      return description.map((msg, idx) => (
        <p key={idx} className="mb-1 text-start">
          <strong>{msg?.code ? "" : `${idx + 1}.`}</strong>{" "}
          {msg?.code
            ? `(${msg?.code?.coding?.[0]?.code}) - ${msg?.code?.coding?.[0]?.display}`
            : msg}
        </p>
      ));
    } else if (typeof description === "string") {
      return <p className="text-center  fs-10 fw-bold">{description}</p>;
    } else {
      return null;
    }
  };

  return (
    <Modal
      show={modal}
      onHide={() => setModal(false)}
      centered
      dialogClassName="wizard-modal"
    >
      <Modal.Body className="text-center px-4">
        <FalconCloseButton
          size="sm"
          className="position-absolute  top-0 end-0 me-2 mt-2"
          onClick={() => setModal(false)}
        />

        <Lottie
          animationData={animationData}
          loop
          style={{ width: 120, height: 120, margin: "0 auto" }}
        />

        <h5 className="mt-3 text-danger fw-bold">{title}</h5>
        <div className="text-muted small mt-2">{renderDescription()}</div>
      </Modal.Body>
    </Modal>
  );
};

ErrorDisplayModal.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ErrorDisplayModal;
